export var TenantAccessPartyResponse;
(function (TenantAccessPartyResponse) {
    /** The request has been made but not yet responded to */
    TenantAccessPartyResponse[TenantAccessPartyResponse["Pending"] = 0] = "Pending";
    /** The tenant has granted access */
    TenantAccessPartyResponse[TenantAccessPartyResponse["Granted"] = 1] = "Granted";
    /** The tenant has denied the request but considers it appropriately made */
    TenantAccessPartyResponse[TenantAccessPartyResponse["DeniedAppropriate"] = 2] = "DeniedAppropriate";
    /**
     * The tenant has denied the request and considers it inappropriately
     * made. There should be corresponding comments explaining why.
     */
    TenantAccessPartyResponse[TenantAccessPartyResponse["DeniedInappropriate"] = 3] = "DeniedInappropriate";
})(TenantAccessPartyResponse || (TenantAccessPartyResponse = {}));
